
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry",
      function () {
        return require("private-next-pages/industry/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry"])
      });
    }
  